<template>
  <div class="dashboard-test-container">
    <h1>🧪 Testing: Admin Dashboard con Datos Reales</h1>
    <p>Este componente simula autenticación para testing directo del dashboard.</p>
    
    <!-- Componente Dashboard Real -->
    <p>P13-V1D: AdminDashboard.new fue retirado (vista huérfana); el dashboard real es la home de cada rol.</p>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

// 🔧 Simular autenticación para testing
const authStore = useAuthStore()

onMounted(async () => {
  console.log('🧪 [TEST] Simulando login de SuperAdmin...')
  
  // Usar el método correcto del store
  const success = await authStore.loginWithTestToken('SuperAdmin')
  
  if (success) {
    console.log('✅ [TEST] Login simulado completado')
  } else {
    console.error('❌ [TEST] Error en login simulado')
  }
})
</script>

<style scoped>
.dashboard-test-container {
  padding: 20px;
}
</style>
